import React, { useState } from "react";
import { CardExpiryElement } from "@stripe/react-stripe-js";
import { StripeCardExpiryElementOptions, StripeElementChangeEvent } from "@stripe/stripe-js";
import { WarningIcon } from "../icons/WarningIcon";

const CardExpiryInput = ({
  stripeElementsOptions,
  tt,
}: {
  stripeElementsOptions: StripeCardExpiryElementOptions;
  tt: {
    expiryDate: string;
  };
}) => {
  const [isCardExpiryEmpty, setCardExpiryEmpty] = useState<boolean>(true);
  const [cardExpiryError, setCardExpiryError] = useState<StripeElementChangeEvent["error"] | null>(null);

  return (
    <div className={`relative rounded-xl text-grey cursor-text select-none w-3/4 mr-1`}>
      <CardExpiryElement
        id="card-expiry-element"
        options={{ ...stripeElementsOptions, placeholder: "" }}
        onChange={(event: any) => {
          setCardExpiryError(event.error);
          if (!event.empty) {
            setCardExpiryEmpty(false);
          } else {
            setCardExpiryEmpty(true);
          }
        }}
      />
      <label
        htmlFor="expiry"
        className={`absolute inset-y-0 py-3.5 px-5 text-lg duration-300 origin-0 w-96 cursor-text pointer-events-none select-none ${
          isCardExpiryEmpty ? "" : "transform scale-70 -translate-y-3.5"
        }`}
      >
        {tt.expiryDate}
      </label>

      {cardExpiryError && (
        <div className="flex flex-row items-center text-xs pt-0.5 text-red">
          <WarningIcon className="mr-1" />
          {cardExpiryError.message}
        </div>
      )}
    </div>
  );
};

export default React.memo(CardExpiryInput);
